<template>
  <div class="p-2 radius-6 position-relative mb-3">
    <p :class="`mb-0 w-100 text-center ${font_size}`" v-if="$isNotEmpty(getActivityTrxExpiredAt)">Spot secured for {{ countdown }} minutes. Enjoy your time!</p>
    <div class="primary-overlay radius-6 z-index-1025"></div>
  </div>
</template>

<script>
  import moment from 'moment';
  import { mapGetters,mapMutations } from 'vuex';

  export default {
    props: {
      font_size:{
        type: String,
        default: 'body-2-1'
      }
    },
    data() {
      return {
        expired_time: null,
        expired_time_interval: null,
        countdown: ''
      }
    },
    computed:{
      ...mapGetters(['getActivityTrxExpiredAt']),
      expired_time_vuex(){
        return this.getActivityTrxExpiredAt
      }
    },
    watch:{
      expired_time_vuex(){
        this.expired_time = this.expired_time_vuex
      },
      expired_time(newVal, oldVal){
        if (newVal !== oldVal) {
          this.calculateCountdown();
          
          if (this.expired_time_interval) {
            clearInterval(this.expired_time_interval);
          }

          this.expired_time_interval = setInterval(() => {
            this.calculateCountdown();
          }, 1000);

        }
      }
    },
    mounted(){
      if(this.$isNotEmpty(this.getActivityTrxExpiredAt)){
        this.expired_time = this.getActivityTrxExpiredAt
      }
    },
    beforeDestroy(){

    },
    methods:{
      ...mapMutations(['clearTrxActivityProduct']),
      calculateCountdown() {
        if (this.expired_time) {
          const now = moment();
          const expirationDate = moment(this.expired_time);
          const duration = moment.duration(expirationDate.diff(now));

          const minutes = moment.utc(duration.asMilliseconds()).format('mm');
          const seconds = moment.utc(duration.asMilliseconds()).format('ss');

          this.countdown = `${minutes}:${seconds}`;

          if (duration.asMilliseconds() <= 0) {
            clearInterval(this.expired_time_interval);
            this.countdown = '0';
            this.clearTrxActivityProduct()
          }
        }
      },
    }
  }
</script>


// WEBPACK FOOTER //
// src/components/hotel/concierge/pos/CartTimer.vue